import { Box, FormControl, FormHelperText, IconButton, InputLabel, MenuItem, Select, SelectProps, Typography } from '@mui/material';
import React from 'react';

interface Option {
  value: string;
  label: string;
}

interface CustomSelectProps {
  label: string;
  options: Option[];
  value: string | undefined;
  onChange: (value: Option) => void;
  error?: boolean;
  helperText?: string;
  errorText?: string;
  disabled?: boolean;
  required?: boolean;
  icon?: any;
  onIconClick?: () => void;
  SelectProps?: Omit<SelectProps<string>, 'value' | 'onChange'>;
  sx?: any;
  variant?: any;
  selectSx?: any;
  renderOption?: (option: Option) => React.ReactNode;
  renderValue?: (option: Option | undefined) => React.ReactNode;
  disableUnderline?: boolean
  size?: any;
}

const CustomSelect: React.FC<CustomSelectProps> = ({
  label,
  options,
  value,
  onChange,
  error,
  helperText,
  errorText,
  disabled,
  required,
  icon: Icon,
  onIconClick,
  SelectProps,
  sx,
  selectSx,
  renderOption,
  renderValue,
  variant,
  disableUnderline,
  size
}) => {
  return (
    <Box bgcolor="white" sx={sx}>
      <FormControl
        fullWidth
        error={error}
        disabled={disabled}
        required={required}
      >
        <InputLabel htmlFor={`${label}-label`} size={size} >{label}</InputLabel>
        <Select
          id={`${label}-label`}
          value={value || ''}
          label={label}
          onChange={(e) => {
            const option = options.find((opt) => opt.value === e.target.value);
            if (option) onChange(option);
          }}
          size={size}
          sx={{ height: size ? undefined : 56, ...selectSx }}
          endAdornment={
            Icon ? (
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  onIconClick?.();
                }}
                size="small"
                sx={{ mr: 2 }}
              >
                <Icon size={20} />
              </IconButton>
            ) : undefined
          }
          variant={variant || "outlined"}
          disableUnderline={disableUnderline}
          renderValue={(selected) => {
            const option = options.find((opt) => opt.value === selected);
            if (renderValue) return renderValue(option);
            return option?.label ?? '';
          }}
          {...SelectProps}
        >
          {options?.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {renderOption ? renderOption(option) : option.label}
            </MenuItem>
          ))}
        </Select>
        {helperText && <FormHelperText>{helperText}</FormHelperText>}
      </FormControl>
      {errorText && (
        <Typography color="error" variant="caption" sx={{ mt: 0.5, ml: 1 }}>
          {errorText}
        </Typography>
      )}
    </Box>
  );
};

export default CustomSelect;
